import { render, staticRenderFns } from "./other-details-form.vue?vue&type=template&id=480cd2f8&scoped=true"
import script from "./other-details-form.vue?vue&type=script&lang=js"
export * from "./other-details-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480cd2f8",
  null
  
)

export default component.exports